import React from "react";
import placeHolder from "../../../assets/images/placeholder/popeh_placeholder.jpg"
import "./TableThumbnail.scss"
import {Fancybox} from "@moeindal/base-raiko-panel-components";
export default function TableThumbnail(
    {
        url = "",
        caption = "",
        alt = "",
        fancyBoxGroup = "gallery"
    }
) {
    return (
        <div className={"fancyboxContainer"}>
            <Fancybox
                options={{
                    Carousel: {
                        infinite: false,
                    },
                }}
            >
                <a
                    href={url}
                    data-fancybox={fancyBoxGroup}
                    data-caption={caption}
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}>
                    <div className={"fancyImageContainer"}>
                        <img src={url && url.length > 0 ? url : placeHolder} alt={alt} className={"fancyImage"}/>
                        <div className={"zoomIconContainer"}>
                            <div className={"zoom_icon"}></div>
                        </div>
                    </div>
                </a>
            </Fancybox>
        </div>


    )
}
